import { Button } from "@/components/button";
import { HeaderPages } from "@/components/header-pages/header-pages";

import { DEFAULT_ROUTES } from "@/constants/routes";
import { Pagination } from "@/features/pagination/layouts/pagination";
import { useBooking } from "@/features/private-room/bookings/hooks/use-booking";

import { Link } from "react-router-dom";

export const BokaoList = () => {
  const { bookings, handleChangePage, activePage, decreasePage, increasePage } =
    useBooking();

  return (
    <>
      <HeaderPages title="Private Room - Bokão">
        <span className="sm:ml-3">
          <Link to={DEFAULT_ROUTES.BOOKING_CREATE}>
            <Button>Criar bokão</Button>
          </Link>
        </span>
      </HeaderPages>
      <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
        <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
            <tr>
              <th scope="col" className="px-6 py-3">
                ID
              </th>
              <th scope="col" className="px-6 py-3">
                Bookão Date
              </th>
              <th scope="col" className="px-6 py-3">
                Space Name - Room Label
              </th>
              <th scope="col" className="px-6 py-3">
                Capacity
              </th>
              <th scope="col" className="px-6 py-3">
                Credits
              </th>
              <th scope="col" className="px-6 py-3">
                Company
              </th>
              <th scope="col" className="px-6 py-3">
                Comission R$
              </th>
              <th scope="col" className="px-6 py-3">
                Transfer R$
              </th>
              <th scope="col" className="px-6 py-3">
                Status
              </th>
              <th scope="col" className="px-6 py-3">
                <span>Action</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {bookings?.map((item) => (
              <tr
                key={item.booking.id}
                className="bg-white border-b  hover:bg-gray-50 "
              >
                <th
                  scope="row"
                  className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap "
                >
                  {item.booking.id}
                </th>
                <td className="px-6 py-4"> {item.booking.booking_detail}</td>

                <td className="px-6 py-4">
                  {item.space.name} - {item.private_room.label}
                </td>
                <td className="px-6 py-4"> {item.private_room.capacity}</td>
                <td className="px-6 py-4">{item.booking.credits}</td>
                <td className="px-6 py-4">{item.booking.company_name}</td>
                <td className="px-6 py-4">
                  {item.booking_attributes.booking_commission_fee}
                </td>
                <td className="px-6 py-4">
                  {" "}
                  {item.booking_attributes.booking_payout}
                </td>
                <td className="px-6 py-4"> {item.booking.status}</td>
                <td className="px-6 py-4 text-right">
                  <a
                    href="#"
                    className="font-medium text-blue-600  hover:underline"
                  >
                    Edit
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Pagination
        count={1000}
        page={activePage}
        onPageClick={handleChangePage}
        onPrevPageClick={decreasePage}
        onNextPageClick={increasePage}
      />
    </>
  );
};
